// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"351":"commons","532":"styles","678":"component---src-pages-index-js","883":"component---src-pages-404-js"}[chunkId] + "-" + {"351":"9cba65e0dabc78535e85","532":"b5c82c35457896750319","678":"5355d68ede5e156e6759","883":"03f46202bf485e3ca613"}[chunkId] + ".js";
};